import React, { FC } from 'react';

import { ResourceMapping } from '@ariksa/inventory-core/api';
import { Box, Center, Flex, Image, Stack, Text } from '@chakra-ui/react';

import {
  AriksaIcon,
  formatTooltip,
  getIconColor,
  renderTooltipFieldValue,
} from 'components/DataDisplay';
import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';
import { isIconFilled } from 'components/Icons/Components/isIconFilled';
import { getBlackMapIcon } from 'components/Icons/MapIcons/getBlackMapIcon';
import { getPurpleMapIcon } from 'components/Icons/MapIcons/getPurpleMapIcon';
import { getWhiteMapIcon } from 'components/Icons/MapIcons/getWhiteMapIcon';
import { IconType } from 'components/Icons/types';

interface IMetaIcon {
  type: IconType;
  resourceType?: ResourceMapping;
  name?: string;
  image?: boolean;
  imageType?: string;
  bg?: string;
  native?: string;
  agnostic?: string;
  field?: string;
  iconFilled?: boolean;
  isInline?: boolean;
  textAlign?: string;
  showTooltip?: boolean;
}

export const MetaIcon: FC<IMetaIcon> = props => {
  const {
    type,
    resourceType,
    name,
    native,
    agnostic,
    bg,
    iconFilled,
    image = false,
    isInline = true,
    textAlign = 'left',
    imageType,
    showTooltip = true,
  } = props;

  const renderMetaIcon = () => (
    <Flex>
      <Stack
        border={'1px solid #ddd'}
        p={4}
        borderRadius={5}
        w="full"
        bg="white"
        spacing={4}
        //direction={isInline ? 'row' : 'column'}
      >
        <Center>
          {!image && (
            <AriksaIcon
              type={type}
              size="medium"
              bg={bg}
              iconFilled={iconFilled}
            />
          )}
          {image && (
            <Center
              w={10}
              h={10}
              p={2}
              bg={
                imageType === 'white' && isIconFilled(type)
                  ? getIconColor(type as string)
                  : 'white'
              }
              borderRadius={6}
            >
              <Image
                src={
                  imageType === 'purple'
                    ? getPurpleMapIcon(type)
                    : imageType === 'black'
                    ? getBlackMapIcon(type)
                    : getWhiteMapIcon(type)
                }
              />
            </Center>
          )}
        </Center>
        <Stack spacing={1} w="full" align="center">
          <Text
            overflow={'hidden'}
            textOverflow={'ellipsis'}
            whiteSpace={'nowrap'}
            fontWeight={600}
          >
            {name || native || resourceType?.cloud_native_name || '-'}
          </Text>
          {(agnostic || resourceType?.cloud_agnostic_name) && (
            <Text fontSize={'sm'}>
              {agnostic || resourceType?.cloud_agnostic_name || '-'}
            </Text>
          )}
          {/*<Text fontSize={'2xs'}>{field}</Text>*/}
        </Stack>
      </Stack>
    </Flex>
  );

  return showTooltip && resourceType ? (
    <Box w="full">
      <CustomTooltip
        label={formatTooltip({
          header: 'Resource Type',
          content: (
            <Stack>
              {renderTooltipFieldValue('Provider', resourceType?.provider)}
              {renderTooltipFieldValue(
                'Native Name',
                resourceType?.cloud_native_name,
              )}
              {renderTooltipFieldValue(
                'Native Class',
                resourceType?.cloud_native_class,
              )}
              {renderTooltipFieldValue(
                'Agnostic Name',
                resourceType?.cloud_agnostic_name,
              )}
              {renderTooltipFieldValue(
                'Agnostic Class',
                resourceType?.cloud_agnostic_class,
              )}
            </Stack>
          ),
          width: 72,
        })}
      >
        {renderMetaIcon()}
      </CustomTooltip>
    </Box>
  ) : (
    renderMetaIcon()
  );
};
